export default __webpack_public_path__ + "static/schedulino-logo-b7a81b53becd3ec20ecbfcb5af735c4c.svg";